import React from "react";
import {message} from "antd";

class ModelUtils {
    static async execute({funName, sucMsg, failMsg, showMsg, duration}, func = async () => null) {
        try {
            let retData = await func()
            if (showMsg && !!retData) message.success(sucMsg, duration);
            return retData;
        } catch (e) {
            if (e && e.retData && e.retCode) {
                message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, duration);
            } else {
                message.error(failMsg, duration);
            }
        }
    }
}

export default ModelUtils;